import { render, staticRenderFns } from "./jy-outboundScanDetail2.vue?vue&type=template&id=97b34bb4&scoped=true&"
import script from "./jy-outboundScanDetail2.vue?vue&type=script&lang=js&"
export * from "./jy-outboundScanDetail2.vue?vue&type=script&lang=js&"
import style0 from "./jy-outboundScanDetail2.vue?vue&type=style&index=0&id=97b34bb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b34bb4",
  null
  
)

export default component.exports